import { ChipMenu, extendableComponent } from '@graphcommerce/next-ui'
import { Trans } from '@lingui/react'
import { ListItem, ListItemText, SxProps, Theme, Checkbox, Box } from '@mui/material'
import { useHitsPerPage } from 'react-instantsearch-hooks-web'

const name = 'ProductListSort' as const
const parts = ['menu', 'item', 'link'] as const
const { classes } = extendableComponent(name, parts)

type CustomHitsPerPageProps = { sx?: SxProps<Theme> }

export function CustomHitsPerPage(props: CustomHitsPerPageProps) {
  const { sx = [] } = props

  const { items, refine } = useHitsPerPage({
    items: [
      { label: '20 Per page', value: 20, default: true },
      { label: '50 Per page', value: 50 },
      { label: '100 Per page', value: 100 },
    ],
  })

  return (
    <ChipMenu
      className={classes.menu}
      variant='outlined'
      label={<Trans id='Per page' />}
      selected={false}
      sx={Array.isArray(sx) ? sx : [sx]}
    >
      <Box>
        {items.map((option) => (
          <ListItem className={classes.item} button key={option?.value ?? ''} dense>
            <ListItemText
              onClick={() => {
                refine(option?.value)
              }}
            >
              <Trans id='{count} Per page' values={{ count: option?.value }} />
              <Checkbox
                edge='start'
                checked={option?.isRefined}
                tabIndex={-1}
                size='medium'
                color='primary'
                disableRipple
                inputProps={{ 'aria-labelledby': `filter-equal-${option?.value}` }}
                sx={[
                  {
                    padding: 0,
                    margin: '0 0 0 0',
                    float: 'right',
                  },
                ]}
              />
            </ListItemText>
          </ListItem>
        ))}
      </Box>
    </ChipMenu>
  )
}
